import { FunctionComponent } from "react";
import { Category } from "../entities/Category/Category";
import { ShareEntityButton } from "../components/buttons/ShareEntityButton/ShareEntityButton";
import { EntityBackButton } from "../components/buttons/EntityBackButton/EntityBackButton";
import { FeedPost } from "@dto/FeedPost";
import { parseEntityDescription } from "@lib/parseEntityDescription";

import "./FeedPostView.css";

interface FeedPostViewProps {
  feedPost: FeedPost;
}

const FeedPostView: FunctionComponent<FeedPostViewProps> = ({ feedPost }) => {
  return (
    <div className="feed-post-container">
      <div
        className="cover-photo"
        style={{
          backgroundImage: `url(${feedPost.coverPhotoUrl})`,
          height: "228px",
        }}>
        <div className="gradient"></div>
        <div className="cover-actions">
          <div className="cover-actions-top">
            <div className="cover-actions-top-left">
              <EntityBackButton />
            </div>
            <div className="cover-actions-top-right">
              <ShareEntityButton entity={feedPost} />
            </div>
          </div>
        </div>
      </div>

      {/* <div className="header">{feedPost.name}</div> */}

      <div className="category-container">
        <Category entity={feedPost} />
      </div>

      <div className="tab-content">
        <div
          dangerouslySetInnerHTML={{
            __html: parseEntityDescription(feedPost.text),
          }}
          data-testid="entity-description"
          className="feedPost-description-container"></div>
      </div>
    </div>
  );
};

export { FeedPostView };
